module.exports = __webpack_public_path__ + "img/device-0.819f2797.png";